export default "__VITE_ASSET__cc330b1d__"